var map = {
	"./Webinar 0.jpg": 1688,
	"./Webinar 1.jpg": 4910,
	"./Webinar 2.jpg": 5177,
	"./Webinar 3.jpg": 4652,
	"./Webinar 4.jpg": 6199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9094;